"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import * as React from "react";
import { Suspense } from "react";
import { Provider } from "react-redux";

import { AuthProvider, JwtProvider, MockModeGate } from "@/providers";
import { store } from "@/redux/store";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<div></div>}>
      {/* Outermost on purpose: auth and RTK Query fire on mount — anything
          above this would reach the network before the worker is active. */}
      <MockModeGate>
        <NuqsAdapter>
          <NextThemesProvider
            attribute="class"
            defaultTheme="light"
            enableColorScheme
          >
            <Provider store={store}>
              <AuthProvider>
                <JwtProvider>{children}</JwtProvider>
              </AuthProvider>
            </Provider>
          </NextThemesProvider>
        </NuqsAdapter>
      </MockModeGate>
    </Suspense>
  );
}
